import {
  locationTypes,
  addLocation,
  updateLocationDetail,
  manageLocationTree,
} from "@/libs/api/api";
import settings from "@/libs/constant/settings";
import { isEmpty, filter, cloneDeep, forEach } from "lodash";
import { message, loader, errorHandler, logout } from "@/libs/helper";
import constants from "@/libs/constant/constants";
import { mapGetters } from "vuex";
import locationFormMixin from "@/mixins/locationFormMixin";

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },

    fetchLocations: {
      type: Function,
      default: () => {},
    },

    addressToBeEdited: {
      type: Object,
      default: () => {},
    },

    editLocation: {
      type: Function,
      default: () => {},
    },
    isMove: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [locationFormMixin],
  data() {
    return {
      isEmpty,
      view: "name",
      selectedName:
        (this.addressToBeEdited && this.addressToBeEdited.locationtype) || {},
      selectedType:
        (this.addressToBeEdited && this.addressToBeEdited.type) || '',
      isFetchingNames: false,
      selectedLanguage: settings.LOCIZE.LANGUAGE.ENGLISH_GB,
      address: {
        country_name:
          (this.addressToBeEdited && this.addressToBeEdited.country_name) ||
          'Netherlands',
        country_code:
          (this.addressToBeEdited && this.addressToBeEdited.country_code) ||
          'NL',
        line1: (this.addressToBeEdited && this.addressToBeEdited.line1) || '',
        line2: (this.addressToBeEdited && this.addressToBeEdited.line2) || '',
        postal_code:
          (this.addressToBeEdited && this.addressToBeEdited.postal_code) || '',
        city: (this.addressToBeEdited && this.addressToBeEdited.city) || '',
        fax: (this.addressToBeEdited && this.addressToBeEdited.fax) || '',
        phone: (this.addressToBeEdited && this.addressToBeEdited.phone) || '',
        email: (this.addressToBeEdited && this.addressToBeEdited.email) || '',
      },
      typesPopover: false,
      typesSearch: "",
      options: [
        { value: "author", label: "Author" },
        { value: "organisation", label: "Organisation" },
        { value: "publication", label: "Publication" },
        { value: "other", label: "Other" },
      ],
      otherForm: {
        name_en_gb:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_en_gb) ||
          '',
        name_en_us:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_en_us) ||
          '',
        name_nl_nl:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_nl_nl) ||
          '',
        name_de_de:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_de_de) ||
          '',
      },
      locNames: [],
      loctionList: {},
      treeLocations: [],
      defaultProps: {
        children: "children",
        label: "name_en_gb",
        childRow: function (h, row) {
          return <div>My custom content for row {row.id}</div>;
        },
      },
    };
  },

  computed: {
    isOther() {
      return this.selectedType === 'other';
    },
    locationsTree() {
      return cloneDeep(this.locations);
    },
    ...mapGetters({
      locations: "getLocations",
    }),
  },

  mounted() {
    // set language
    this.setLanguage();
    if (this.isMove) {
      this.view = "tree";
      this.$emit("stopMove");
    }
    if (this.isEdit) {
      this.address = {
        country_name:
          (this.addressToBeEdited && this.addressToBeEdited.country_name) ||
          'Netherlands',
        country_code:
          (this.addressToBeEdited && this.addressToBeEdited.country_code) ||
          'NL',
        line1: (this.addressToBeEdited && this.addressToBeEdited.line1) || '',
        line2: (this.addressToBeEdited && this.addressToBeEdited.line2) || '',
        postal_code:
          (this.addressToBeEdited && this.addressToBeEdited.postal_code) || '',
        city: (this.addressToBeEdited && this.addressToBeEdited.city) || '',
        fax: (this.addressToBeEdited && this.addressToBeEdited.fax) || '',
        phone: (this.addressToBeEdited && this.addressToBeEdited.phone) || '',
        email: (this.addressToBeEdited && this.addressToBeEdited.email) || '',
      };

      this.otherForm = {
        name_en_gb:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_en_gb) ||
          '',
        name_en_us:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_en_us) ||
          '',
        name_nl_nl:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_nl_nl) ||
          '',
        name_de_de:
          (this.addressToBeEdited &&
            this.addressToBeEdited.locationtype &&
            this.addressToBeEdited.locationtype.name_de_de) ||
          '',
      };

      this.selectedName =
        (this.addressToBeEdited && this.addressToBeEdited.locationtype) || {};

      this.selectedType =
        (this.addressToBeEdited && this.addressToBeEdited.type) || '';
      this.getLocationNamesList();
    }
  },

  beforeMount() {
    this.intialiseCountry();
  },

  watch: {
    addressToBeEdited(newValue) {
      this.address = {
        country_name: newValue.country_name || 'Netherlands',
        country_code: newValue.country_code || 'NL',
        line1: newValue.line1 || '',
        line2: newValue.line2 || '',
        postal_code: newValue.postal_code || '',
        city: newValue.city || '',
        fax: newValue.fax || '',
        phone: newValue.phone || '',
        email: newValue.email || '',
      };

      this.otherForm = {
        name_en_gb:
          (newValue.locationtype && newValue.locationtype.name_en_gb) || '',
        name_en_us:
          (newValue.locationtype && newValue.locationtype.name_en_us) || '',
        name_nl_nl:
          (newValue.locationtype && newValue.locationtype.name_nl_nl) || '',
        name_de_de:
          (newValue.locationtype && newValue.locationtype.name_de_de) || '',
      };

      this.selectedType =
        newValue.type ||
        (newValue.locationtype && newValue.locationtype.type) ||
        '';
      this.selectedName = newValue.locationtype || {};
    },

    isMove(isTrue) {
      if (isTrue) {
        this.view = "tree";
        this.$emit("stopMove");
      }
    },
  },

  methods: {
    /**
     * switch between the 3 tabbed views in the dialog box
     */
    changeView(viewName) {
      this.view = viewName;
    },

    async addLocation() {
      let isDisabled = false;

      // validate loc form
      this.$refs["loc-form"].validate((valid) => {
        if (!valid) {
          isDisabled = true;
        }
        // if is other validate other form
        if (this.isOther) {
          this.$refs["otherForm"].validate((valid) => {
            if (!valid) {
              isDisabled = true;
            }
          });
        }

        // if diabled show error message
        if (isDisabled) {
          message(
            this,
            constants.messageType.ERROR,
            "Some Fields are not filled or are invalid"
          );
          return;
        }

        loader(this, true);

        const body = {
          type: this.selectedType.toUpperCase(),
          entity_id: this.$route.params.id,
          location_type_id: this.selectedName._id,
          ...this.address,
        };
        if (!isEmpty(this.selectedState)) {
          body.state = this.selectedState._id;
        }
        if (this.isOther) {
          body.name_en_gb = this.otherForm.name_en_gb;
          body.name_en_us = this.otherForm.name_en_us;
          body.name_de_de = this.otherForm.name_de_de;
          body.name_nl_nl = this.otherForm.name_nl_nl;
        }
        // edit
        if (this.isEdit) {
          delete body.entity_id;
          updateLocationDetail(this.addressToBeEdited._id, body)
            .then((response) => {
              message(this, constants.messageType.SUCCESS, response.message);
              // refresh locations
              this.fetchLocations(true);
              loader(this, false);
            })
            .catch((error) => {
              message(
                this,
                constants.messageType.ERROR,
                errorHandler(error, logout.bind(this, this))
              );
              loader(this, false);
            });
        }

        // add location
        else {
          // api call
          addLocation(body)
            .then(() => {
              this.fetchLocations(true);
              message(
                this,
                constants.messageType.SUCCESS,
                "Location added successfully"
              );
              loader(this, false);
            })
            .catch((error) => {
              message(
                this,
                constants.messageType.ERROR,
                errorHandler(error, logout.bind(this, this))
              );
              loader(this, false);
            });
        }
      });
    },

    /**
     * edit location
     * @param {*} data
     */
    editAddress(data) {
      //edit the tree item
      this.view = "address";
      this.editLocation(data);
    },

    /**
     * to get the list of loc types
     */
    getLocationNamesList() {
      this.isFetchingNames = true;
      locationTypes(this.selectedType.toUpperCase())
        .then((response) => {
          this.locNames = response.result || [];
          // location
          if (!this.isOther)
            this.loctionList[this.selectedType] =
              (response && response.result) || [];
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.isFetchingNames = false;
        });
    },

    /**
     * to set the language
     */
    setLanguage() {
      let language = localStorage.getItem("lang");
      this.selectedLanguage = language || settings.LOCIZE.LANGUAGE.ENGLISH_GB;
    },

    /**
     * handler for selected type changed
     */
    changeTypeHandler(type) {
      this.selectedType = type;
      if (!this.isOther && !this.loctionList[this.selectedType]) {
        // get loc type list
        this.getLocationNamesList();
      }
    },

    /**
     * filter on the location list
     * @param {*} search
     */
    filterLocationList() {},

    handleInputConfirm(item) {
      this.address.country_code = item.country_code || '';
      this.address.country_name = item.country_name || '';
      this.states = [];
      this.searchState = '';
      this.selectedState = {};
      this.fetchStateList(item);
    },
    querySearch: async function (search, cb) {
      if (search === "" && search === null && search.length < 1) return;
      let results = [];
      if (!isEmpty(this.countries)) {
        results = await filter(this.countries, (c) => {
          return c.country_name.toLowerCase().includes(search.toLowerCase());
        });
      }
      cb(results);
    },
    getCountryName() {
      let result = "";
      if (this.address && this.address.country_code) {
        filter(this.countries, (country) => {
          if (country.country_code === this.address.country_code) {
            result = country.country_name;
            // fetch state list initially
            this.fetchStateList(country);
          }
        });
      }
      return result;
    },
    /**
     * intialise country name
     */
    intialiseCountry() {
      // set address and by defult it is netherlands
      if (this.addressToBeEdited && !isEmpty(this.addressToBeEdited)) {
        this.address.country_name = this.getCountryName();
      } else {
        this.address.country_name = 'Netherlands';
        this.address.country_code = 'NL';
      }
    },

    allowDrop() {
      return true;
    },

    allowDrag() {
      return true;
    },

    handleDrop() {
      this.storeUpdateTreePositions();
    },

    /**
     * to store the tree positions
     */
    storeUpdateTreePositions() {
      let result = [];
      if (!isEmpty(this.locationsTree)) {
        loader(this, true);
        forEach(this.locationsTree, (loc) => {
          const rootLocation = { ...loc };
          delete rootLocation.children;
          delete rootLocation.parent;
          result.push(rootLocation);
          const t = this.flatten(loc);
          result = result.concat(t);
        });
        result = result.map((loc) => {
          const location = {
            location_id: loc._id,
            order: loc.order || 0,
          };
          if (loc.parent) location.parent = loc.parent;
          return location;
        });
        const body = {
          locations: result || [],
        };
        manageLocationTree(body)
          .then((response) => {
            // update locations
            this.fetchLocations(true);
            // message
            message(this, constants.messageType.SUCCESS, response.message);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            loader(this, false);
          });
      }
    },

    //my own creation
    flatten(treeObj, idAttr, parentAttr, childrenAttr, levelAttr) {
      if (!idAttr) idAttr = "_id";
      if (!parentAttr) parentAttr = "parent";
      if (!childrenAttr) childrenAttr = "children";
      if (!levelAttr) levelAttr = "order";

      function flattenChild(childObj, parentId, level) {
        var array = [];

        var childCopy = { ...childObj };
        childCopy[levelAttr] = level;
        childCopy[parentAttr] = parentId;
        delete childCopy[childrenAttr];
        array.push(childCopy);

        array = array.concat(processChildren(childObj, level));

        return array;
      }

      function processChildren(obj, level) {
        if (!level) level = 0;
        var array = [];

        if (obj[childrenAttr]) {
          obj[childrenAttr].forEach(function (childObj) {
            array = array.concat(
              flattenChild(childObj, obj[idAttr], level + 1)
            );
          });
        }

        return array;
      }

      var result = processChildren(treeObj);
      return result;
    },
  },
};
